export const MAP_ROUTER_PATH = {
  home: "/",
  city: "/:city",
  plot: "/:city/:id",
  wallet:"/wallet",
  myLands: "/my-lands",
  about: "/about",
};